import React, { ReactNode, useState } from "react";
import SecNavigationDesktop from "../../../generic/SecNavigation/SecNavigationDesktop";
import NavigationDropdown from "../../../generic/navigationDropdown";
import { secNavOptions, newOfferOptions, scrlStCls } from "../obConstants";
import NavigationTag from "../../../generic/navigationTag";
import { ObScrollService } from "../../../service/orderBook/obScrollService";
import { useParams } from "react-router-dom";
import { IListObj } from "../../../types/genericTypes";
import "../../../../assets/scss/components/generic/layout/layoutDesk.scss";
import "../../../../assets/scss/components/toc/orderBook/obContainer/obContainerDesk.scss";

export interface IObContainerDeskProps {
	priNavOptions?: Array<IListObj>;

	instComp?: ReactNode;
	isPriNavHidden?: boolean;
	// primary market related props
	handleInstNav?: (value: any) => void;
}

const ObContainerDesk: React.FC<IObContainerDeskProps> = (props: IObContainerDeskProps) => {
	const [isFixed, setIsFixed] = useState<boolean>(false);
	const { secNav, pageNav, inst } = useParams<{ secNav: string; pageNav: string; inst: string }>(); //section navigation,page navigation, primary market instrument

	function onContainerScroll(e: React.UIEvent<HTMLElement>) {
		// console.dir((e.target as HTMLElement).scrollTop);
		// if scrolltop is greater than 78 then fix the header
		(e.target as HTMLElement).scrollTop > (inst ? 88 : 50) ? !isFixed && setIsFixed(true) : isFixed && setIsFixed(false);

		setTimeout(() => {
			ObScrollService(isFixed);
		});
	}

	return (
		<section className={"outer_container container_desk " + (props.isPriNavHidden ? " selectActive" : "") + (isFixed ? " obScrollActive" : "")}>
			<section className="ob_container lyCont">
				<section className="list_view">
					{/* left block */}
					<div className="ly_list_view">
						<SecNavigationDesktop defaultValue={secNav} list={secNavOptions()} />
					</div>
					{/* right block which contains page navigation and other controls */}

					<div className="ob_right_cont ly_right_cont" onScroll={onContainerScroll} id={scrlStCls.pContId}>
						<div className={"ob_tbl_header" + (inst ? " by2" : "")}>
							{props.priNavOptions && (
								<NavigationDropdown
									type="page_nav"
									defaultValue={pageNav}
									dropdownOptions={props.priNavOptions}
									onSelect={() => {}}
								/>
							)}
							{/* new offers navigation */}
							{inst && (
								<div className="taRight">
									<NavigationTag
										defaultValue={inst || "today"}
										tagList={newOfferOptions}
										onSelect={props.handleInstNav ? props.handleInstNav : () => {}}
									/>
								</div>
							)}
						</div>

						<div className={"ob_history obTableData"}>{props.instComp}</div>
					</div>
				</section>
			</section>
		</section>
	);
};

export default ObContainerDesk;
